import React, { useState, useRef, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import axios from "axios";
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Col, Row, Form, Input, Radio } from 'antd';
import { toast } from 'react-toastify';
import loading from '../../assets/img/loading-gif.gif';
import filesearch from '../../assets/img/filesearch.png';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Table from 'react-bootstrap/Table';
import { useNavigate } from 'react-router-dom';


export default function Copypaste() {
  const [areCombinationsGenerated, setAreCombinationsGenerated] = useState(false);
  const [WithoutPlati, setWithoutPlati] = useState('WithPlati');
  const navigate = useNavigate();
  const [showSubmitButton, setShowSubmitButton] = useState(true);
  const [isButtonVisible, setIsButtonVisible] = useState(true);
  const [users, setUsers] = useState([]);
  const [selectedOption, setSelectedOption] = useState('option1');
  const [points, setPoints] = useState(0);
  const [totalPoints, setTotalPoints] = useState();
  const [user_balance, setuser_balance] = useState();
  const [MaxbetAmt, setMaxbet] = useState([]);
  const [setminibet, setMinibet] = useState([]);
  const [Maxpoints, setMaxpoints] = useState([]);
  const url = new URL(window.location.href);
  const gameid = url.searchParams.get('id');
  const url1 = new URL(window.location.href);
  const name = url1.searchParams.get('name');
  const [appmanagerdata, setAppmanager] = useState(null);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
   console.warn("copy",isButtonDisabled)
  const [banned, setbanned] = useState([]);

  const [minredeem, setMinredeem] = useState(null);
  const isButtonLoading = useRef(false);
  // const [selectedRadio, setSelectedRadio] = useState('');
  const onFinish = () => {
    // message.success('Submit success!');
  };

  const onFinishFailed = () => {
    // message.error('Submit failed!');
  };
  const handleRadioChange = (e) => {
    setSelectedOption(e.target.value);
  };


  const [loading2, setLoading2] = useState(false);

  const [nums, setNums] = useState('');
  const [combinations, setCombinations] = useState([]);
  const [input, setInput] = useState('');
  const [result, setResult] = useState([]);
  const [plati, setPlati] = useState('');
  const [radioValue, setRadioValue] = useState('WithPlati')
  const [pid, setpid] = useState([]);

  const onChangeValue = (event) => {
    setPlati(event.target.value);
    console.log(event.target.value);
  };

  const handleInputChange = (e) => {
    setInput(e.target.value);
  };
  // useEffect(() => {

  //   generateSubstrings();

  // }, []); 


  const generateSubstrings = () => {
    let i = 0;
    let newCombinations = [];

    if (!nums) {
      toast.error('Number is required.');
      return;
    }

    if (!points) {
      toast.error('Points is required.');
      return;
    }

    while (i < nums.length) {
      let tmp1 = '';
      let tmp2 = '';
      if (i === nums.length - 1) {
        tmp1 += nums[i] + nums[i];
        newCombinations.push(tmp1);
      } else {
        tmp1 += nums[i] + nums[i + 1];
        tmp2 += nums[i + 1] + nums[i];
        newCombinations.push(tmp1);
        newCombinations.push(tmp2);
      }
      i = i + 2;
    }


    const uniqueCombinations = [...new Set(newCombinations)];
    setCombinations(uniqueCombinations);
  };

  const deleteCombination1 = (index) => {
    const updatedCombinations = [...combinations];
    updatedCombinations.splice(index, 1);
    setCombinations(updatedCombinations);

    const newTotalPoints = updatedCombinations.length; // Calculate points based on the number of combinations
    setTotalPoints(newTotalPoints);
    toast.success('Combination deleted successfully!');
  };




  const generateCombinations = () => {
    const numArray = nums.split('').map(Number);
    const n = numArray.length;


    if (!nums) {
      toast.error('Number is required.');
      return;
    }

    if (!points) {
      toast.error('Points is required.');
      return;
    }

    let combinations = [];
    // console.warn()
    if (n % 2 == 0) {

      for (let i = 0; i < n; i += 2) {
        const pair = [numArray[i]];
        if (i + 1 < n) {
          pair.push(numArray[i + 1]);
        }
        combinations.push(pair);


      }


    } else {
      if (n % 2 !== 0) {

        toast.error('Must be Even Digit.');
        return {

        };
      }
    }

    const uniqueCombinations = combinations.filter(
      (combination, index, self) =>
        index ===
        self.findIndex(
          (c) =>
            c.length === combination.length &&
            c.every((value, i) => value === combination[i])
        )
    );

    setCombinations(uniqueCombinations);
    setAreCombinationsGenerated(true);

  };
  function handleChange(evt) {
    setNums(evt.target.value);

  }
  const combinationsCount = combinations.length;
  var totalpoint = combinationsCount * points

  const deleteCombination = (index) => {
    const updatedCombinations = [...combinations];
    updatedCombinations.splice(index, 1);
    setCombinations(updatedCombinations);

    const updatedPoints = combinationsCount > 1 ? points : 0;
    const newTotalPoints = updatedCombinations.length * updatedPoints;
    setTotalPoints(newTotalPoints);
    toast.success('Combination deleted successfully! ');


  };

  useEffect(() => {
    loaduser();
    app_manager();
    loaduser1();
    loadUserpid();
  }, [])
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);



  const loadUserpid = async () => {
    try {
        const user_id = localStorage.getItem('userid');
        const devid = localStorage.getItem('dev_id');

        let url = `${process.env.REACT_APP_API_URL}/home`;

        const requestData = {
            app_id: process.env.REACT_APP_API_ID,
            user_id: user_id,
            dev_id: devid
        };

        const response = await axios.post(url, requestData, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        const objectRes = response.data;
        const user_balance = response.data.user_balance;
        setuser_balance(user_balance)
        const currentDate = objectRes.current_date;
        const pid = objectRes.pid;
        
        setpid(pid);

    } catch (error) {
        console.error('Error loading user data:', error);
    }
};


  const loaduser1 = async () => {
    try {
        const user_id = localStorage.getItem("userid");
        const dev_id = localStorage.getItem("dev_id");

        if (!user_id || !dev_id) {
            console.warn("🚨 Missing user_id or dev_id in localStorage.");
            return;
        }

        const url = `${process.env.REACT_APP_API_URL}/POM_get_user_profile`;

        // JSON request payload
        const requestData = {
            app_id: process.env.REACT_APP_API_ID,
            user_id:user_id,
            dev_id:dev_id,
        };

        // Sending request as JSON
        const response = await axios.post(url, requestData, {
            headers: {
                "Content-Type": "application/json"
            }
        });

        // Axios automatically parses JSON response
        const objectRes = response.data;

        if (objectRes) {
            setbanned(objectRes.banned || false); // Default to false if undefined
            console.warn("✅ User data loaded successfully.");
        } else {
            console.warn("⚠️ No user data received from API.");
        }

    } catch (error) {
        console.error("🚨 Error fetching user profile:", error);
    }
};
const app_manager = async () => {
  try {
    const user_id = localStorage.getItem("userid");
    const dev_id = localStorage.getItem("dev_id");
    const url = `${process.env.REACT_APP_API_URL}/app-manager`;

    const requestData = {
      app_id: process.env.REACT_APP_API_ID,
      user_id:user_id,
      dev_id:dev_id,
    };

    const response = await axios.post(url, requestData, {
      headers: { "Content-Type": "application/json" }
    });

    if (response?.data) {
      const { points, data } = response.data;
      setMaxpoints(points);

      if (data) {
        const { min_redeem, jodi_min, jodi_max } = data;

        console.warn("Min Redeem:", min_redeem);
        console.warn("Jodi Min:", jodi_min);
        console.warn("Jodi Max:", jodi_max);

        setAppmanager(data);
        setMinibet(jodi_min);
        setMaxbet(jodi_max);
      }

      console.warn("Full Response Data:", JSON.stringify(data, null, 2));
    }
  } catch (error) {
    console.error("Error in app_manager:", error);
  }
};


  const loaduser = async () => {
    // setLoading(true);
    const user_id = localStorage.getItem("userid");
    const dev_id = localStorage.getItem("dev_id");
    // alert(dev_id);
    try {

      // console.warn(url);
      const formData = new FormData();
      formData.append('app_id', process.env.REACT_APP_API_ID);
      formData.append('user_id', user_id);
      formData.append('market_id', gameid);
      formData.append('dev_id', dev_id);
      var config = {
        method: 'POST',
        url: url,
        body: formData,
      };
      axios.post(url, formData, config)
        .then(function (response) {
          var setmininumbet = response.data.mini_bet;
          var setmax_betnumbet = response.data.max_bet;
          var setpoints = response.data.points;
          setMinibet(setmininumbet)
          setMaxbet(setmax_betnumbet)
          setMaxpoints(setpoints)
          console.warn(setpoints)
          const res = JSON.stringify(response.data);
          const objectRes = JSON.parse(res);
          setUsers(objectRes);
          console.warn(objectRes);
        })
        .finally(() => {
          // setLoading(false);
        });
    } catch (error) {
      console.error('There was a problem with the fetch operation:', error);
      //   setLoading(false);
    }
  }
  const clearInputValues = () => {
    console.warn(setCombinations + 'dem0');
    setCombinations(Array().fill(''));
  };
  // const loaduser2 = async () => {
  //   const user_id = localStorage.getItem("userid");
  //   const dev_id = localStorage.getItem("dev_id");
  //   let url = (`${process.env.REACT_APP_API_URL}/POM_get_user_profile.php`);
  //   const formData = new FormData();
  //   formData.append('app_id', process.env.REACT_APP_API_ID);
  //   formData.append('user_id', user_id);
  //   formData.append('dev_id', dev_id);
  //   var config = {
  //     method: 'POST',
  //     url: url,
  //     body: formData,
  //   };
  //   axios.post(url, formData, config)
  //     .then(function (response) {
  //       const res = JSON.stringify(response.data);
  //       const refcode = response.data.refCode;
  //       const objectRes = JSON.parse(res);
  //       const login_token = localStorage.getItem('login_token');
        
  //       console.warn(objectRes.login_token);
  //       if(objectRes.login_token != login_token){
  //         localStorage.clear();
  //         navigate('/login');
  //       }
  //     })
  // }
  const loaduser2 = async () => {
    try {
      const user_id = localStorage.getItem("userid");
      const dev_id = localStorage.getItem("dev_id");
      const url = `${process.env.REACT_APP_API_URL}/POM_get_user_profile`;
  
      const requestData = {
        app_id: process.env.REACT_APP_API_ID,
        user_id: user_id,
        dev_id: dev_id,
      };
  
      const response = await axios.post(url, requestData, {
        headers: { "Content-Type": "application/json" },
      });
  
      if (response?.data) {
        const { login_token, refCode } = response.data;
  
        console.warn("Login Token:", login_token);
  
        if (login_token !== localStorage.getItem("login_token")) {
          localStorage.clear();
          navigate("/login");
        }
      }
    } catch (error) {
      console.error("Error in loaduser2:", error);
    }
  };
  

  const handlePlayGame = () => {

   


    // alert("hello")
    setIsButtonDisabled(true);
    // setIsButtonDisabled(false);
        setTimeout(() => {
          setIsButtonDisabled(false);
      }, 5000);

    loaduser2();
    if (banned == '0') {
      clearInputValues();

      // playgame();
      setTimeout(() => {
        playgame();
      }, 1000); // 2-second delay


    } else if (banned == '1') {
      setLoading2(true);
      setTimeout(() => {
        setLoading2(false);
      }, 20000);
    }
  };

  const playgame = async () => {
    // setIsButtonDisabled(false);

    const batuniqueid = `${Date.now()}_${Math.floor(Math.random() * 1000)}`;

    console.warn('dddd')
    const user_id = localStorage.getItem("userid");
    const dev_id = localStorage.getItem("dev_id");

    console.warn(setminibet);
    console.warn(MaxbetAmt);
    console.warn(points);
    // console.warn(totalPoints);
    if (parseInt(setminibet) > parseInt(points)) {
      console.warn('pppp');
      toast.error(`Minimum Bet Placed ${appmanagerdata.jodi_min}`);
      return;
    }
    if (parseInt(MaxbetAmt) < parseInt(points)) {
      console.warn('11111');

      toast.error(`Maximum Bet Placed ${appmanagerdata.jodi_max}`);
      return;
    }
    if (users.points < totalpoint) {
      toast.error(`You Dont Have Sufficient Balance`);
      return;
    }
    console.warn('565656');

    setIsButtonVisible(false);
    if (!isButtonLoading.current) {
      isButtonLoading.current = true;

      // setIsButtonDisabled(true);
      // setTimeout(() => {
      // setIsButtonDisabled(false);
      isButtonLoading.current = false;
      // }, 1000);
    }
    try {
      const betList = selectedOption === 'option2'
        ? combinations
          .map((combination, index) => {
            return {
              betkey: combination.join(''),
              betamount: points,
              session_name: "open",
              bettype: '8',
            };
          })
          .filter(item => item.betamount > 0)
        : combinations
          .map((substring, index) => {
            return {
              betkey: substring,
              betamount: points,
              session_name: "open",
              bettype: '8',
            };
          })
          .filter(item => item.betamount > 0);
      // setLoading2(false);

      const response = await axios.post(`${process.env.REACT_APP_API_URL}/bat-place`, {
        user_id: user_id,
        dev_id: dev_id,
        pid: pid,
        market_id: gameid,
        app_id: process.env.REACT_APP_API_ID,
        BetList: betList,
        dev_model: "web",
        devName: "sumsang",
        batuniqueid:batuniqueid

      });

      if (response.data.success == 1) {
        // setTimeout(() => {
        // setLoading2(false);
        // }, 1000);
        // console.warn(response.data.success)
        // setShowSubmitButton(false);
        const MySwal = withReactContent(Swal)
        MySwal.fire({
          title: response.data.message,
          icon: 'success',
          timer: 2500
        })
          .then((result) => {
            navigate('/');
          })
      }  else if (response.data.success == 0) {
        setLoading2(false);
        setShowSubmitButton(true);
      
        const MySwal = withReactContent(Swal);
        MySwal.fire({
          title: 'Error',
          text: response.data.message || 'Something went wrong!',
          icon: 'error',
          confirmButtonText: 'OK',
        });
      }else {
        const MySwal = withReactContent(Swal)
        MySwal.fire({
          title: response.data.message,
          timer: 2000,
          icon: 'error'
        });
        return;
      }

      // return;
    } catch (error) {
      console.error('Game store:', error);
      toast.error('An error occurred while Game store. Please try again later.');
    }

    // setLoading2(true);

  };
  const [form] = Form.useForm();

  return (
    <>
      <section id="copyright">
        <div className="d-flex justify-content-between px-3">
          <div className="points">
            {/* <h5>Points Remaining :</h5> */}
            <h5>Points Remaining : {Math.max(0, user_balance) - (combinationsCount * points)}</h5>
            {/* <h5>Points Remaining: dfasd {Math.max(0, user_balance - totalPoints)}</h5> */}
            </div>
          {/* <div className="points">
            <h5>Points Added</h5>
            <p>{combinationsCount * points}</p>
          </div> */}
        </div>
        <div className="form">
          <Form
            form={form}
            layout="vertical"

          >
            {selectedOption === 'option1' &&

              <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
                className="d-flex justify-content-between w-100"
              >
                <Form.Item label="Number" >
                  <Input placeholder="Number" inputMode='numeric' type='text' className="inputfile" value={nums}
                    onPaste={(e) => {
                      e.preventDefault();
                      const pastedText = e.clipboardData.getData('text/plain').replace(/[^0-9]/g, '').slice(0, 2);
                      document.execCommand('insertText', false, pastedText);
                    }}
                    onChange={(e) => {

                      const inputValue = e.target.value.replace(/[^0-9]/g, '');
                      setNums(inputValue)
                    }} />
                </Form.Item>
              </Form>
            }
            {selectedOption === 'option2' &&
              <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
                className="d-flex justify-content-between w-100"
              >
                <Form.Item label="Number" >
                  <Input placeholder="Number" className="inputfile" value={nums}
                    onPaste={(e) => {
                      e.preventDefault();
                      const pastedText = e.clipboardData.getData('text/plain').replace(/[^0-9]/g, '').slice(0, 2);
                      document.execCommand('insertText', false, pastedText);
                    }}
                    onChange={(e) => {
                      const inputValue = e.target.value.replace(/[^0-9]/g, '');
                      setNums(inputValue)
                    }} />
                </Form.Item>
              </Form>
            }

            <div className="d-flex">
              <div className='d-flex align-items-center mt-2'>

                <input
                  type="radio"
                  value="option1"
                  onChange={handleRadioChange}
                  checked={selectedOption === 'option1'}
                  name="addfund"
                  id="googlepay"
                />
                <label className='ps-1'>With Plati</label>

              </div>
              <div className='d-flex align-items-center mt-2'>

                <input
                  type="radio"
                  value="option2"
                  onChange={handleRadioChange}
                  checked={selectedOption === 'option2'}
                  name="addfund"
                  id="paytm"
                  className='ms-3'
                />
                <label className='ps-1'>Without Plati</label>

              </div>
            </div>
            <Form.Item
              label="Amount"
              className='margin-top-15'
            >
              {/* <Input placeholder="Number" className="inputfile"
               onChange={(e) =>{
                const inputValue = e.target.value.replace(/[^0-9]/g, '');
                setPoints((inputValue))} } /> */}
              <Input
                placeholder="Number"

                className="inputfile"
                type='text'
                inputMode='numeric'
                pattern='[0-9]*'
                onPaste={(e) => {
                  e.preventDefault();
                  const pastedText = e.clipboardData.getData('text/plain').replace(/[^0-9]/g, '');
                  document.execCommand('insertText', false, pastedText);
                }}
                onChange={(e) => {
                  const inputValue = e.target.value.replace(/[^0-9]/g, '');
                  setPoints(inputValue);
                }}
                onInput={(e) => {
                  const inputValue = e.target.value.replace(/[^0-9]/g, '');
                  e.target.value = inputValue; // Ensure the input value is updated
                  setPoints(inputValue);
                }}
                autoFocus />
            </Form.Item>
            {/* <Form.Item> */}
            {/* {selectedOption === 'option2' ?(
              
              ):(
            )
              <Button type="button" className="btn_submit"     onChange={handleRadioChange}
                  checked={selectedOption === 'option2'} onClick={generateCombinations}>Add</Button>
            </Form.Item> */}
            {selectedOption === 'option2' ? (
              <Form.Item>
                <Button type="button" className="btn_submit w-100"
                  onClick={generateCombinations}>Add</Button>
              </Form.Item>
            ) : (
              <Button type="button" className="btn_submit w-100"
                onClick={generateSubstrings}>Add</Button>
            )}
          </Form>
        </div>
        <div className='card'>

          <table className='table'>
            <thead>
              <tr>
                <td>Number Type</td>
                <td>Number</td>
                <td>Points</td>
              </tr>
            </thead>
            <tbody>
              {selectedOption === 'option2' ? (
                combinations.map((substring, index) => (
                  <tr key={index}>
                    <td>Jodi</td>
                    <td>{substring}</td>
                    <td>{points}</td>
                    <td className='text-danger' onClick={() => deleteCombination1(index)}>
                      <i className="bi bi-trash3"></i>
                    </td>
                  </tr>
                ))


              ) : (
                combinations.map((combination, index) => (
                  <tr key={index}>
                    <td>Jodi</td>
                    <td>{combination}</td>
                    <td>{points}</td>
                    <td className='text-danger' onClick={() => deleteCombination(index)}>
                      <i className="bi bi-trash3"></i>
                    </td>
                  </tr>
                ))
              )}



            </tbody>
          </table>

        </div>

        <div class="totalpoints">
          <div class="d-flex justify-content-between">
            <p>₹</p>
            <p className='ms-1'>{combinationsCount * points}</p>
          </div>
          {showSubmitButton && <button disabled={isButtonDisabled} class="btn_submit" onClick={handlePlayGame} >Play  </button>}
        </div>
      </section>
      <ToastContainer />
      {loading2 && (
        <div className="spinner-wrapper">
          <div className="loadernew2"></div>
        </div>
      )}
    </>
  )
}
